// extracted by mini-css-extract-plugin
export default {"melodyVideo":"kL-z","isFullWidth":"lL-z","landingPageVideo":"mL-z","play":"nL-z","iframeVideo":"oL-z","playHidden":"pL-z","fullwidth":"qL-z"};